import ProfileInfoReducer from "./profileInfoReducer";
import ViewPublishReducer from "./jobs/publishJobsReducre"
import ReferCandidate from "./jobs/referalCandiReducer"
import ApplyJobs from "./jobs/applyJobReducer"
import MatchedJobs from './jobs/matchedJobsReducer'
import { combineReducers } from "redux";

export default combineReducers({
  profile: ProfileInfoReducer,
  viewPublishJobs: ViewPublishReducer,
  ReferCandidate: ReferCandidate,
  ApplyJobs: ApplyJobs,
  MatchedJobs:MatchedJobs
});
